export const getFormSchemas = async (showLaaCodes = true) => {
  return {
    CDSI: {
      pageTitle: 'Investigations',
      fields: [
        {
          id: 'CDSIN',
          description: 'Class',
          apiPropertyName: 'investigationFeeClass',
          type: 'list',
          length: null,
          readOnly: true
        },
        {
          id: 'LAA_CODE',
          description: 'Fee Code',
          apiPropertyName: 'investigationLaaFeeCodeId',
          type: 'laa',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSICC',
          description: 'Stage reached',
          apiPropertyName: 'investigationStageReached',
          type: 'list',
          length: null,
          readOnly: showLaaCodes === true
        },
        {
          id: 'CDSIOUC',
          description: 'Outcome code',
          apiPropertyName: 'investigationOutcomeCode',
          type: 'list',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSIOFC',
          description: 'Offence code',
          apiPropertyName: 'investigationOffenceCode',
          type: 'list',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSINSD',
          description: 'Number of suspects',
          apiPropertyName: 'investigationSuspectsCount',
          type: 'string',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSINPC',
          description: 'No Police/Court Attendances',
          apiPropertyName: 'investigationCourtAttendancesCount',
          type: 'string',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSIPCI',
          description: 'Police/court ident',
          apiPropertyName: 'investigationCourtIdent',
          type: 'list',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSIDS',
          description: 'Duty solicitor',
          apiPropertyName: 'investigationDutySolicitor',
          type: 'list',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSIYC',
          description: 'Youth court',
          apiPropertyName: 'investigationYouthCourt',
          type: 'list',
          length: null,
          readOnly: showLaaCodes === true
        },
        {
          id: 'CDSISCM',
          description: 'Scheme ID',
          apiPropertyName: 'investigationSchemeId',
          type: 'list',
          length: null,
          readOnly: false
        },
        {
          id: 'DSCC_NUMBER',
          description: 'DSCC Number',
          apiPropertyName: 'investigationDsccNumber',
          type: 'string',
          length: 10,
          readOnly: false
        }
      ]
    },
    CDSPR: {
      pageTitle: 'Proceedings',
      fields: [
        {
          id: 'CDSPR',
          description: 'Class',
          apiPropertyName: 'proceedingFeeClass',
          type: 'list',
          length: null,
          readOnly: true
        },
        {
          id: 'CDSROD',
          description: 'Representation Order Date',
          apiPropertyName: 'proceedingRepresentationOrderDate',
          type: 'date',
          length: null,
          readOnly: false
        },
        {
          id: 'LAA_CODE',
          description: 'Fee Code',
          apiPropertyName: 'proceedingLaaFeeCodeId',
          type: 'laa',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSPRSF',
          description: 'CDS Standard Fee',
          apiPropertyName: 'proceedingStandardFee',
          type: 'list',
          length: null,
          readOnly: showLaaCodes === true
        },
        {
          id: 'CDSPRCC',
          description: 'Stage Reached',
          apiPropertyName: 'proceedingStageReached',
          type: 'list',
          length: null,
          readOnly: showLaaCodes === true
        },
        {
          id: 'CDSCAT1C',
          description: 'Category 1 Subcategory',
          apiPropertyName: 'proceedingCategory1SubCategory',
          type: 'list',
          length: null,
          readOnly: showLaaCodes === true
        },
        {
          id: 'CDSPROFC',
          description: 'Offence Code',
          apiPropertyName: 'proceedingOffenceCode',
          type: 'list',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSPRNSD',
          description: 'Number of Suspects',
          apiPropertyName: 'proceedingSuspectsCount',
          type: 'string',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSPRNPC',
          description: 'No Police/Court Attendances',
          apiPropertyName: 'proceedingCourtAttendancesCount',
          type: 'string',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSPRPCI',
          description: 'Police/Court Ident',
          apiPropertyName: 'proceedingCourtIdent',
          type: 'list',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSPROUC',
          description: 'Outcome Code',
          apiPropertyName: 'proceedingOutcomeCode',
          type: 'list',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSPRDS',
          description: 'Duty Solicitor',
          apiPropertyName: 'proceedingDutySolicitor',
          type: 'list',
          length: null,
          readOnly: showLaaCodes === true
        },
        {
          id: 'CDSPRYC',
          description: 'Youth Court',
          apiPropertyName: 'proceedingYouthCourt',
          type: 'list',
          length: null,
          readOnly: showLaaCodes === true
        },
        {
          id: 'MAAT_ID',
          description: 'MAAT Id',
          apiPropertyName: 'proceedingMaatId',
          type: 'string',
          length: 10,
          readOnly: false
        }
      ]
    },
    CDSAR: {
      pageTitle: 'Appeals & reviews',
      fields: [
        {
          id: 'CDSAR',
          description: 'Class',
          apiPropertyName: 'appealReviewFeeClass',
          type: 'list',
          length: null,
          readOnly: true
        },
        {
          id: 'LAA_CODE',
          description: 'Fee Code',
          apiPropertyName: 'appealReviewLaaFeeCodeId',
          type: 'laa',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSARCC',
          description: 'Stage Reached',
          apiPropertyName: 'appealReviewStageReached',
          type: 'list',
          length: null,
          readOnly: showLaaCodes === true
        },
        {
          id: 'CDSAROUC',
          description: 'Outcome Code',
          apiPropertyName: 'appealReviewOutcomeCode',
          type: 'list',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSAROFC',
          description: 'Offence Code',
          apiPropertyName: 'appealReviewOffenceCode',
          type: 'list',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSARNSD',
          description: 'Number of Suspects',
          apiPropertyName: 'appealReviewSuspectsCount',
          type: 'string',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSARNPC',
          description: 'No Police/Court Attendances',
          apiPropertyName: 'appealReviewCourtAttendancesCount',
          type: 'string',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSARPCI',
          description: 'Police/Court Ident',
          apiPropertyName: 'appealReviewCourtIdent',
          type: 'list',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSARDS',
          description: 'Duty Solicitor',
          apiPropertyName: 'appealReviewDutySolicitor',
          type: 'list',
          length: null,
          readOnly: showLaaCodes === true
        },
        {
          id: 'CDSARYC',
          description: 'Youth Court',
          apiPropertyName: 'appealReviewYouthCourt',
          type: 'list',
          length: null,
          readOnly: showLaaCodes === true
        }
      ]
    },
    CDSPL: {
      pageTitle: 'Prison law',
      fields: [
        {
          id: 'CDSPL',
          description: 'Class',
          apiPropertyName: 'prisonLawFeeClass',
          type: 'list',
          length: null,
          readOnly: true
        },
        {
          id: 'LAA_CODE',
          description: 'Fee Code',
          apiPropertyName: 'prisonLawLaaFeeCodeId',
          type: 'laa',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSPLCC',
          description: 'Stage Reached',
          apiPropertyName: 'prisonLawStageReached',
          type: 'list',
          length: null,
          readOnly: showLaaCodes === true
        },
        {
          id: 'CDSPLOUC',
          description: 'Outcome Code',
          apiPropertyName: 'prisonLawOutcomeCode',
          type: 'list',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSPLOFC',
          description: 'Offence Code',
          apiPropertyName: 'prisonLawOffenceCode',
          type: 'list',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSPLNSD',
          description: 'Number of Suspects',
          apiPropertyName: 'prisonLawSuspectsCount',
          type: 'string',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSPLNPC',
          description: 'No Police/Court Attendances',
          apiPropertyName: 'prisonLawCourtAttendancesCount',
          type: 'string',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSPLPCI',
          description: 'Prison Code',
          apiPropertyName: 'prisonLawPrisonCode',
          type: 'list',
          length: null,
          readOnly: false
        },
        {
          id: 'CDSPLDS',
          description: 'Duty Solicitor',
          apiPropertyName: 'prisonLawDutySolicitor',
          type: 'list',
          length: null,
          readOnly: showLaaCodes === true
        },
        {
          id: 'CDSPLYC',
          description: 'Youth Court',
          apiPropertyName: 'prisonLawYouthCourt',
          type: 'list',
          length: null,
          readOnly: showLaaCodes === true
        },
        {
          id: 'PA_NUMBER',
          description: 'Prior Approval Number',
          apiPropertyName: 'prisonLawPriorApprovalNumber',
          type: 'string',
          length: 10,
          readOnly: false
        }
      ]
    }
  }
}
